import React from "react";
import ModalBlank from "./ModalBlank";
import { Modal, ModalContent } from "@nextui-org/react";

export default function ModalImage({
  modalOpen,
  setModalOpen,
  image,
  setImage,
}) {
  return (
    <Modal
      placement="center"
      isOpen={modalOpen}
      onOpenChange={(isOpen) => setModalOpen(isOpen)}
      classNames={{ backdrop: "z-[51]", wrapper: "z-[60]" }}
    >
      <ModalContent className="pointer-events-auto">
        {(onClose) => (
          <div className="p-3">
            <img className="w-full" src={image} alt="Image" />
          </div>
        )}
      </ModalContent>
    </Modal>
  );
}
